/** @format */

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DataTable from "./DataTable";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import axios from "axios";

const productColumns = [
  {
    field: "productId",
    headerName: "Product Id",
    width: 150,
    renderCell: (params) => {
      return (
        <NavLink to={`/product/${params.row.productId}`}>
          {params.row.productId}
        </NavLink>
      );
    },
  },
  {
    field: "vendorId",
    headerName: "Vendor Id",
    width: 150,
    renderCell: (params) => {
      return (
        <NavLink to={`/vendor/${params.row.vendorId}`}>
          {params.row.vendorId}
        </NavLink>
      );
    },
  },
  { field: "productName", headerName: "Product Name", width: 200 },
  {
    field: "productDescription",
    headerName: "Product Description",
    width: 400,
  },
  {
    field: "productIdentifier",
    headerName: "Product Identifier",
    width: 200,
    renderCell: (params) => (
      <Chip
        label={params.row.productIdentifier}
        variant="outlined"
        sx={{ width: "120px" }}
        color="success"
      />
    ),
  },
];

const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  async function deleteProducts(productsIds) {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/product/removeProducts`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
          data: productsIds,
        }
      );
      console.log(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function getAllProducts() {
    setIsFetching(true);
    try {
      const productsList = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/product/getAllProducts`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(productsList.data);
      const formatedProductList = productsList.data.map((product) => {
        return {
          id: product.productId,
          productId: product.productId,
          vendorId: product.vendorId,
          productName: product.productName,
          productDescription: product.productDesc,
          productIdentifier: product.productIdentifier,
        };
      });
      setProducts(formatedProductList);
    } catch (err) {
      console.log(err);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    getAllProducts();
  }, []);

  return (
    <>
      {isFetching ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          <Alert
            severity="success"
            color="success"
            sx={{ my: 2 }}
            iconMapping={{
              success: <FormatListBulletedIcon fontSize="inherit" />,
            }}>
            <Typography component="h1" variant="h6">
              List of All Products
            </Typography>
          </Alert>
          <DataTable
            rows={products}
            columns={productColumns}
            updateList={setProducts}
            deleteList={deleteProducts}
          />
        </>
      )}
    </>
  );
};

export default AllProducts;
